<template>
  <teleport to="#modals-container">
      <transition name="video-modal">
          <div v-if="modelValue" class="video-modal-bg">
              <div class="video-modal" ref="modalRef">
                  <iframe :src="`https://www.youtube.com/embed/${videoId}`"
                          title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen></iframe>
                  <svg @click="$emit('update:modelValue', false)" width="32" height="32" viewBox="0 0 20 20"
                       fill="white">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586
                      10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1
                      0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                  </svg>

          </div>
          </div>
      </transition>
  </teleport>
</template>

<script setup>
import { ref } from "vue";
import { onClickOutside } from '@vueuse/core'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    videoId: {
        type: String,
    }
})
const emit = defineEmits(['update:modelValue'])

const modalRef = ref(null)
onClickOutside(modalRef, () => {
        emit('update:modelValue', false)
    },
);
</script>

<style lang="scss">
.video-modal-bg {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000000ad;
    z-index: 10;

    .video-modal {
        position: relative;
        height: 450px;
        max-width: 800px;
        width: 100%;
        margin: 0 1rem;

        @media screen and (max-width: 425px) {
            height: 220px;
        }

        > svg {
            position: absolute;
            top: -19px;
            right: -16px;
            cursor: pointer;
        }

        iframe, object, embed {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            margin: 0 auto;
        }
    }
}

.video-modal-enter-active,
.video-modal-leave-active {
    transition: opacity .15s ease-in-out, transform .15s ease-in-out;
}

.video-modal-enter-from,
.video-modal-leave-to {
    opacity: 0;
    transform-origin: center;
    transform: scale(1.08);
}

</style>
